<template>
  <div class="shop-form__block">
      <span
        class="button grey"
        :class="{ active: loyalityShopData.receiver === 'other' }"
        @click="setCurrentReceiver('other')"
        >В подарок</span
      >
      <span
        class="button grey"
        :class="{ active: loyalityShopData.receiver === 'self' }"
        @click="setCurrentReceiver('self')"
        >Себе</span
      >
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import {TypeLoyalityKinds} from '@/types'
import { IloyalityShopData, TypeReceiver } from "@/types/typesOfState";
import {Store} from 'vuex'


const store = useStore()

const loyalityShopData = computed<IloyalityShopData>(() => store.state.loyalityShopData)
const currentLoyalityKind = computed<TypeLoyalityKinds>(() => store.state.currentLoyalityKind)

function setCurrentReceiver(newLoyalityKind: TypeReceiver): void {
  store.state.loyalityShopData.receiver = newLoyalityKind
}
</script>

<style>

</style>